$(function () {
    $.ajaxSetup({headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}});

    let $body = $("body");

    $('.js-date-time-field')
        .attr('autocomplete', 'off')
        .datetimepicker({
            //format: localization.date_time_format,
            format: 'YYYY-MM-DD HH:mm:ss',
            locale: 'es',
            icons: {
                time: 'fas fa-clock'
            },
        });

    $body.on("click", ".product-buy-shop", function(e){
        e.preventDefault();

        let product = $(this).data("product");
        let shop = $(this).data("shop");
        let url = $(this).data("url");

        let event = 'click_' + product+'_' + shop;
        let category = 'Click_Torrey_Comprar_producto_' + product+'_' + shop;
        let label = 'Click Boton Comprar';

        gtag('event', event, { 'event_category': category, 'event_label': label, 'value': '0' });

        window.open(url,'_blank');

    });

    $body.on("click", "#product-buy", function(e){
        e.preventDefault();

        let product = $(this).data("product");
        let event = 'click_' + product;
        let category = 'Click_Torrey_Comprar_Distribuidores_producto_' + product;
        let label = 'Click Boton Comprar Distribuidores';

        gtag('event', event, { 'event_category': category, 'event_label': label, 'value': '0' });

    });

    $body.on("click", "#product-dealers", function(e){
        e.preventDefault();

        let product = $(this).data("product");
        let event = 'click_' + product;
        let category = 'Click_Encuentra_tu_tienda_producto_' + product;
        let label = 'Click Boton Encuentra tu tienda';

        gtag('event', event, { 'event_category': category, 'event_label': label, 'value': '0' });
    });

    $body.on("click", "#product-seller", function(e){
        e.preventDefault();

        let product = $(this).data("product");
        let event = 'click_' + product;
        let category = 'Click_Contactar_vendedor_producto_' + product;
        let label = 'Click Boton Contactar vendedor';

        gtag('event', event, { 'event_category': category, 'event_label': label, 'value': '0' });
    });

    $body.on("click", ".js-pdf", function(e){
        e.preventDefault();

        let route = $(this).data("route");
        let publication = $(this).data("publication");

        bodyShowLoading();

        $.ajax({
            url: route,
            method: 'GET',
            data: {
                'publication': publication,
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                var disposition = xhr.getResponseHeader('Content-Disposition');
                if (disposition) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches !== null && matches[1]) filename = matches[1].replace(/['"]/g, '');
                }

                var blob = new Blob([response], { type: 'application/octet-stream' });
                var URL = window.URL || window.webkitURL;
                var downloadUrl = URL.createObjectURL(blob);

                if (filename) {
                    var a = document.createElement("a");
                    if (typeof a.download === 'undefined') {
                        window.location = downloadUrl;
                    } else {
                        a.href = downloadUrl;
                        a.download = filename;
                        document.body.appendChild(a);
                        a.target = "_blank";
                        a.click();
                    }
                } else {
                    window.location = downloadUrl;
                }
                bodyHideLoading();

            },
        });
    });

    /*$body.on("click", ".js-contact-button", function (e) {
        e.preventDefault();
        $('.js-cotization-form').css('display','none');
        $('.js-contact-form').toggle();
        if($(this).is(":hidden")){
            $(this).find('h3').css('color','#ED1C24');
            $('.js-cotization-button').find('img').toggleClass('c-contact__filter');
            console.log('visible contact');
        }
    });

    $body.on("click", ".js-cotization-button", function (e) {
        e.preventDefault();
        $('.js-contact-form').css('display','none');
        $('.js-cotization-form').toggle();
        if($(this).is(":hidden")){
            $(this).find('h3').css('color','#ED1C24');
            $('.js-contact-button').find('img').toggleClass('c-contact__filter');
            console.log('visible cotization');
        }
    });*/

    $body.on("click", ".stripe-button", function (e) {
        e.preventDefault();
        let plan = $(this).data("plan");
        let currency = $(this).data("currency");
        $('.stripe-modal-plan').html(plan.stripe_plan+' subscription / '+plan.cost+currency);
        $('.stripe-modal-id').val(plan.id)
    });

    $body.on("click", ".btn-search", function (e) {
        e.preventDefault();
        $('.panel-search').toggle();
        $('.panel-logo').toggle();
    });

    $body.on("click", ".c-editor__all", function (e) {
        e.preventDefault();
        $('.c-editor__library').toggle();
        $('.c-editor__description').toggle();
    });

    $body.on("click", ".c-subscription__arrow", function (e) {
        e.preventDefault();
        $('.c-subscription__data').toggle();
        $('.c-subscription__arrow-icon').toggle();
    });

    $body.on("click", ".c-subscription__close", function (e) {
        e.preventDefault();
        $('.c-subscription__data').hide();
    });

    $body.on("click", ".js-body-loading", function () {
        bodyShowLoading();
    });

    $body.on("click", ".js-button-loading", function () {
        buttonShowLoading($(this), false);
    });

    $body.on("click", ".js-confirm-dialog", function (e) {
        e.preventDefault();
        const $this = $(this);
        const params = {
            message: $this.data("message"),
            submessage: $this.data("submessage"),
            textarea: $this.data("textarea"),
            route: $this.data("route")
        };
        showConfirmDialog(params);
    });

    $body.on("click", ".js-change-status", function(e){
        e.preventDefault();
        let message = $(this).data("message");
        let route = $(this).data("route");
        let comment = $(this).data("comment");
        let config = {
            animation: false,
            title: message,
            type: 'question',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            confirmButtonText: Lang.get('messages.accept'),
            cancelButtonText: Lang.get('messages.cancel'),
            confirmButtonClass: 'btn btn-success',
            cancelButtonClass: 'btn btn-primary ml-4',
        };
        if (comment) {
            config['input'] = 'textarea';
            config['inputPlaceholder'] = Lang.get('messages.include_message_if_you_want');
            config['preConfirm'] = function(result) {
                return axios.post(route, {
                    message: result
                }).then(function (response) {
                    window.location.reload(true);
                });
            };
        }
        else {
            config['preConfirm'] = function(result) {
                return axios.post(route, {
                    //
                }).then(function (response) {
                    window.location.reload(true);
                });
            };
        }
        swal(config);
    });

    $body.on("click", ".js_more", function(e){
        e.preventDefault();

        let div = '.'+$(this).data("list");
        let path = $(this).data("route");
        let offset = $(this).data("offset");
        let type = $(this).data("type");
        let category = $(this).data("category");
        let items = $(this).data("items");

        $.ajax({
            url: path,
            method: 'GET',
            data: {
                'offset': offset,
                'type': type,
                'category': category,
                'items': items,
            },
            success: function(respuesta) {
                //Controlo si hay que ocultar el boton
                if(respuesta.paging.show == false){
                    $(div+'_button').toggle();
                }
                $(respuesta.data).each(function( key, value ) {
                    switch (type) {
                        case 1 : showMoreProducts(div, value); break;
                        case 2 : showMorePodcasts(div, value); break;
                        case 3 : showMoreVideos(div, value); break;
                    }
                });
            },
            error: function() {
                console.log("No se ha podido obtener la información");
            }
        });
        //Actualizo el offset
        $(this).data('offset', offset+items);
    });

    $body.on("click", ".js_more_news", function(e){
        e.preventDefault();

        let div = '.news_list';
        let path = $(this).data("route");
        let offset = $(this).data("offset");
        let items = 20;

        $.ajax({
            url: path,
            method: 'GET',
            data: {
                'offset': offset,
                'items': items,
            },
            success: function(respuesta) {

                //Controlo si hay que ocultar el boton
                if(respuesta.paging.show == false){
                    $(div+'_button').toggle();
                }
                $(respuesta.data).each(function( key, value ) {
                    //console.log(value);
                    let template = $($('#template-news').html());
                    let text = value['text'] ? value['text'].substr(3, 300) : '';
                    /*template
                        .find('.c-widget-new__image')
                        .attr('href', route('frontend.news.view', value['slug'] ))
                        .attr('style', 'background-image: url("'+value['final_image']+'"')*/
                    template
                        .find('.c-widget-news__title')
                        .attr('href', route('frontend.news.view', value['slug'] ))
                        .html(value['title'])
                    template
                        .find('.c-widget-news__excerpt')
                        .html(text+'...')
                    let html_info = value['editors_list'];
                    if(value['source']){
                        html_info += ' - <a href="'+ value['link'] +'" target="_blank">'+ value['source']+'</a>';
                    }
                    html_info += ' - '+ value['date'];
                    if(value['region_name']){
                        html_info += '<span class="c-widget-news__region">'+ value['region_name']+'</span>';
                    }
                    template
                        .find('.c-widget-news__info')
                        .html(html_info)
                    template.appendTo(div);
                });
            },
            error: function() {
                console.log("No se ha podido obtener la información");
            }
        });
        //Actualizo el offset
        $(this).data('offset', offset+items);
    });

    $('[data-toggle="tooltip"]').tooltip();

    $('.js-select2').select2({
        //placeholder: Lang.get('messages.select_an_option'),
        //allowClear: true
    });

    $('.js-selectpicker').selectpicker({
        'liveSearch': true,
    });

    $('.js-selectpicker-single')
        .selectpicker({
            'liveSearch': true,
            'maxOptions': 1,
        });

    $('.js-date-field').datetimepicker({
        useCurrent: false,
        format: localization.date_format,
        locale: localization.language_code2,
    });

    $('.js-datatable').DataTable({
        lengthMenu: [
            [25, 50, 100, -1],
            [25, 50, 100, Lang.get('messages.all_pages')]
        ],
        info: false,
        dom: '<"top"<"left">f<"clear">>rt<"bottom"lp<"clear">>',
        order: [],
        language: { url: '/js/vendor/datatables/locales/' + localization.language_code5 + '.json' },
    });

    //Fix dropdown buttons overflow in table responsive
    $('.table-responsive')
        .on('shown.bs.dropdown', function (e) {
            let t = $(this),
                m = $(e.target).find('.dropdown-menu'),
                tb = t.offset().top + t.height(),
                mb = m.offset().top + m.outerHeight(true),
                d = 20; // Space for shadow + scrollbar.
            if (t[0].scrollWidth > t.innerWidth()) {
                if (mb + d > tb) {
                    t.css('padding-bottom', ((mb + d) - tb));
                }
            } else {
                t.css('overflow', 'visible');
            }
        })
        .on('hidden.bs.dropdown', function () {
            $(this).css({'padding-bottom': '', 'overflow': ''});
        });


    //Slide Home
    var $slideHome = $('.js-slide-home');
    $slideHome.slick({
        fade: true,
        arrows: true,
        dots: true,
        cssEase: 'ease-in-out',
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 800,
        //vertical:true,
        //verticalSwiping: true,
        appendDots: jQuery('.c-slide__dots-container'),
        nextArrow: jQuery('.c-slide__view-detail'),
    });

    //Slide Humanization
    var $slideHumanization = $('.js-slide-humanization');
    $slideHumanization.on('init', function(e, slick) {
        var $firstAnimatingElements = $('div.c-widget-new-alt:first-child').find('[data-animation]');
        doAnimations($firstAnimatingElements);
    });
    $slideHumanization.on('beforeChange', function(e, slick, currentSlide, nextSlide) {
        var $animatingElements = $('div.c-widget-new-alt[data-slick-index="' + nextSlide + '"]').find('[data-animation]');
        doAnimations($animatingElements);
    });
    $slideHumanization.slick({
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        dots: false,
        fade: true
    });

    function doAnimations(elements) {
        var animationEndEvents = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        elements.each(function() {
            var $this = $(this);
            var $animationDelay = $this.data('delay');
            var $animationType = 'animated ' + $this.data('animation');
            $this.css({
                'animation-delay': $animationDelay,
                '-webkit-animation-delay': $animationDelay
            });
            $this.addClass($animationType).one(animationEndEvents, function() {
                $this.removeClass($animationType);
            });
        });
    }
});

window.showMoreProducts = function (div, value) {
    let template = $($('#template-products').html());
    let abst = value['abstract'] ? value['abstract'].substr(3, 120) : '';
    template
        .find('.c-widget-new__image')
        .attr('href', route('frontend.products.view', value['slug'] ))
        .attr('style', 'background-image: url("'+value['final_image']+'"')
    template
        .find('.c-widget-new__author')
        .attr('href', route('frontend.editors.view', value['editors'][0]['slug'] ))
        .html(value['editors'][0]['name'])
    template
        .find('.c-widget-new__title')
        .attr('href', route('frontend.products.view', value['slug'] ))
        .html(value['title'])
    template
        .find('.c-widget-new__excerpt')
        .html(abst+'...')
    template
        .find('.c-widget-meta-more__comments')
        .html('<span class="ElegantIcons">&#x76;</span> '+value['comments_count'])
    template
        .find('.c-widget-meta-more__date')
        .html(value['date'])
    template
        .find('.c-widget-meta-more__readmore-link')
        .attr('href', route('frontend.products.view', value['slug'] ))
    template.appendTo(div);
};

window.showMorePodcasts = function (div, value) {
    let template = $($('#template-podcasts').html());
    let abst = value['abstract'] ? value['abstract'].substr(3, 120) : '';
    template
        .find('.c-widget-podcast__image')
        .attr('href', route('frontend.podcasts.view', value['slug'] ))
        .attr('style', 'background-image: url("'+value['final_image']+'"')
    template
        .find('.c-widget-podcast__title')
        .attr('href', route('frontend.podcasts.view', value['slug'] ))
        .html(value['title'])
    template
        .find('.c-widget-podcast__editor')
        .attr('href', route('frontend.editors.view', value['editors'][0]['slug'] ))
        .html(value['editors'][0]['name'])
    template
        .find('.c-widget-podcast__comments')
        .html('<span class="ElegantIcons">&#x76;</span> '+value['comments_count'])
    template
        .find('.c-widget-podcast__date')
        .html(value['date'])
    template.appendTo(div);
};

window.showMoreVideos = function (div, value) {

    let template = $($('#template-videos').html());
    template
        .find('.c-widget-video-products__image')
        .attr('href', route('frontend.videos.view', value['slug'] ))
        .attr('style', 'background-image: url("'+value['final_image']+'"')
    /*template
        .find('.c-widget-new__author')
        .attr('href', route('frontend.editors.view', value['editors'][0]['id'] ))
        .html(value['editors'][0]['name'])*/
    template
        .find('.c-widget-video-products__title')
        .attr('href', route('frontend.videos.view', value['slug'] ))
        .html(value['title'])
    template
        .find('.c-widget-video-products__comments')
        .html('<span class="ElegantIcons">&#x76;</span> '+value['comments_count'])
    template
        .find('.c-widget-video-products__date')
        .html(value['date'])
    template.appendTo(div);
};

window.bodyShowLoading = function () {
    swal({
        animation: false,
        title: Lang.get('messages.processing'),
        showConfirmButton: false,
        allowOutsideClick: false,
    });
    swal.showLoading();
};

window.bodyHideLoading = function () {
    swal.close();
};

window.buttonShowLoading = function (btn, changeWidth) {
    if (changeWidth) {
        let width = btn.width();
        btn.width(width);
    }
    btn.addClass('disabled');
    btn.html('<i class="fa fa-spinner fa-spin fa-fw fa-custom"></i>');
};

window.buttonHideLoading = function (btn, text) {
    btn.removeClass('disabled');
    btn.html(text);
};

window.checkSession = function (route) {
    setInterval(function() {
        axios.get(route)
            .then(function (response) {
                //console.log(response.data.result);
                if (response.data.result === 'error')
                    window.location.replace(response.data.url);
            });
    }, 1000 * 60); // 1 min
};

/**
 * Instructions
 * 1. type => [
 *     success,
 *     info,
 *     warning,
 *     error
 * ]
 * 2. message
 * 3. duration (in seconds) => 0 to infinite
 * 4. position => [
 *     top-right,
 *     bottom-right,
 *     bottom-left,
 *     top-left,
 *     top-full-width,
 *     bottom-full-width,
 *     top-center,
 *     bottom-center
 * ]
 */
window.showMessage = function ($params) {
    let type = $params[0] || 'success';
    let text = $params[1] || 'Ok';
    let duration = $params[2] || '5';
    let position = $params[3] || 'top-right';

    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": false,
        "progressBar": true,
        "positionClass": "toast-" + position,
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": duration * 1000,
        "extendedTimeOut": duration * 1000,
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };
    switch (type) {
        case 'success':
            toastr.success(text);
            break;
        case 'info':
            toastr.info(text);
            break;
        case 'warning':
            toastr.warning(text);
            break;
        case 'error':
            toastr.error(text);
            break;
    }
};

/*window.showConfirmDialog = function(message, callback) {
    swal({
        animation: false,
        title: message,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: Lang.get('messages.accept'),
        cancelButtonText: Lang.get('messages.cancel'),
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-primary ml-4',
        buttonsStyling: false
    }).then((result) => {
        if (result.value) callback();
    });
};*/
window.showConfirmDialog = function(params) {
    if (params.callback === undefined) {
        params.callback = () => { };
    }

    // Init swal config
    let config = {
        animation: false,
        title: params.message,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: Lang.get('messages.accept'),
        cancelButtonText: Lang.get('messages.cancel'),
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-primary ml-4',
        buttonsStyling: false
    };

    // Check texarea
    let textEditor;
    if (params.textarea !== undefined) {
        config = { ...config,
            allowOutsideClick: false,
            customClass: 'swal-textarea',
            html: '<p>' + params.submessage + '</p><textarea id="message" name="message" class="text-editor"></textarea>',
            onOpen: () => {
                ClassicEditor
                    .create(document.querySelector("#message"), textEditorConfig)
                    .then((editor) => {
                        textEditor = editor;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },
        };
    }

    if (params.route !== undefined) {
        // Check ajax
        let ajax = false;
        let methods = ['GET', 'POST', 'PUT', 'PATCH'];
        methods.forEach((method) => {
            if (params.route.startsWith(method)) {
                ajax = true;
            }
        });

        // Ajax config
        if (ajax) {
            let route = params.route.split(" ");
            if (params.textarea !== undefined) {
                config = {
                    ...config,
                    showLoaderOnConfirm: true,
                    preConfirm: (response) => {
                        //console.log(response);
                        return showConfirmDialogAjax(
                            route[0],
                            route[1],
                            { message: textEditor.getData() }
                        ).catch(function (error) {
                            //console.error(error.response.data);
                            swal.showValidationMessage(error.response.data.message);
                        });
                    }
                };
            } else {
                config = {
                    ...config,
                    preConfirm: (response) => {
                        //console.log(response);
                        return showConfirmDialogAjax(
                            route[0],
                            route[1],
                            { }
                        ).catch(function (error) {
                            //console.error(error.response.data);
                            swal.showValidationMessage(error.response.data.message);
                        });
                    }
                }
            }
        } else {
            params.callback = (response) => {
                //console.log(response);
                if (response.value) {
                    bodyShowLoading();
                    window.document.location = params.route
                }
            };
        }
    }

    // Launch swal
    swal(config).then(params.callback);
};
